// ai_setting API client
const API_BASE_URL = '/deepai/api/ai-settings';
/**
 * AI設定一覧を取得
 */
export async function fetchAiSettings() {
    try {
        const response = await fetch(`${API_BASE_URL}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        console.error('Error fetching AI settings:', error);
        throw error;
    }
}
/**
 * 特定のAI設定を取得
 */
export async function fetchAiSetting(id) {
    try {
        const response = await fetch(`${API_BASE_URL}/${id}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        console.error('Error fetching AI setting:', error);
        throw error;
    }
}
/**
 * AI設定を作成
 */
export async function createAiSetting(data) {
    try {
        const response = await fetch(`${API_BASE_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        console.error('Error creating AI setting:', error);
        throw error;
    }
}
/**
 * AI設定を更新
 */
export async function updateAiSetting(id, data) {
    try {
        const response = await fetch(`${API_BASE_URL}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        console.error('Error updating AI setting:', error);
        throw error;
    }
}
/**
 * AI設定を削除
 */
export async function deleteAiSetting(id) {
    try {
        const response = await fetch(`${API_BASE_URL}/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }
    catch (error) {
        console.error('Error deleting AI setting:', error);
        throw error;
    }
}
/**
 * デフォルト設定値を取得
 */
export function getDefaultAiSetting() {
    return {
        ai_name: '',
        jitsi_config: {
            domain: 'meeting.deepai.jp',
            muc_domain: 'conference.meeting.deepai.jp',
            bosh_url: 'https://meeting.deepai.jp/http-bind',
            url: 'https://meeting.deepai.jp',
            room_name: 'room05',
            chatbot: {
                activate: false,
                welcome_message_delay: 3,
                max_age_seconds: 60,
                message_queue_threshold: 10
            },
            videobot: {
                activate: true,
                bot: {
                    activate: true
                },
                client: {
                    port: 5555,
                    host: 'localhost',
                    myname: ['ZeroMQ-Bot', 'watanabe', 'AIBot']
                },
                stress_checker: {
                    activate: true,
                    system_prompt_path: './voicebot_server/assets/stress_checker_base_prompt.md',
                    sample_rate: 16000,
                    use_custom_sysnthesizer: true
                }
            }
        },
        auto_speak: {
            activate: false
        },
        text_emotion: {
            activate: true,
            model_path: './pretrained_models/emotional_facegen/text_emotion/model.safetensors',
            base_model_root: './pretrained_models/emotional_facegen/text_emotion/bert-base-japanese-whole-word-masking'
        },
        chat: {
            type: 'BaseResponseGenerator',
            config_path: './voicebot_server/config/kiriyama_stress/chat.yaml'
        },
        process_message: true,
        deepai_client: {
            base_url: 'https://meeting.deepai.jp'
        },
        debug: false,
        chat_config: {
            gemma_aizuchi: {
                model_path: '/mnt/NAS3/98_personal/watanabe_y/LLM/gemmma_finetune/train_logs/checkpoint-60350',
                tokenizer_path: '/mnt/NAS3/98_personal/watanabe_y/LLM/gemmma_finetune/gemma-2-2b-jpn-it'
            },
            response: {
                system_prompt_file: 'voicebot_server/config/kiriyama_stress/kiriyama_yurika_prompt.md',
                system_prompt_file_dev: 'assets/chat/system_prompt/tamura/tamura_pc09.md',
                system_prompt_file_okada: 'assets/chat/system_prompt/okada/20241221.txt',
                aizuchi_system_prompt_file: './assets/chat/system_prompt/aizuchi/gemma_system_prompt_dev_reaction.md',
                chatgpt_model_name: 'gpt-4o',
                max_chars: 30,
                min_chars: 10,
                max_history: 5,
                openai_api_key: ''
            }
        }
    };
}
